import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Heading, ActionRadioGroup } = designSystem;

const ActionRadioGroupControl = ({
  title,
  options,
  selectedId,
  isAdvancedFontCustomizationAvailable,
  onChange,
}) => (
  <div className="ws-design-fonts-dialog__control">
    <Heading type="heading-6" singleLine>
      {title}
    </Heading>
    <ActionRadioGroup
      gap="auto"
      options={options}
      selectedId={selectedId}
      preventActiveItemChange={!isAdvancedFontCustomizationAvailable}
      onChange={onChange}
    />
  </div>
);

ActionRadioGroupControl.propTypes = {
  title: PropTypes.node.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      glyph: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  selectedId: PropTypes.string.isRequired,
  isAdvancedFontCustomizationAvailable: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ActionRadioGroupControl;
